const ROOT = process.env.REACT_APP_API_GRAPHQL;
const rutasCMS = {
  navigation:
    ROOT +
    // "?query={rutas(status:PUBLISHED){bag{contentItems{... on Ruta{name keywords title h1 description url component identificadorSitio}}}}}",
    "?query={ruta(status:PUBLISHED){name keywords title h1 description url component identificadorSitio}}",
  secciones: ROOT + "?query={seccion {id,titulo}}",
  barraNavegacionSecundaria:
    ROOT +
    "?query={barraNavegacionSecundariaLogo(status:PUBLISHED){alternateText imagen{urls}} barraNavegacionSecundariaCopyText{text{html}} barraNavegacionSecundariaLinkBtn{textoalternativo imagen{urls} imagen2x{urls} imagen3x{urls}}}",
  barraNavegacionPrincipal:
    ROOT +
    "?query={opciondemenu(status:PUBLISHED){icono{urls} descripcion{html}}}",
  productosAhorroCredito:
    ROOT +
    "?query={productosAhorroYCredito{bag{contentItems{displayText ... on ProductoAhorroCredito{descripcion{html} imagen{urls} url{url}}}}}}",
  barraIntermedia:
    ROOT +
    "?query={aCBarraIntermedia(status:PUBLISHED){descripcion{html} imagenBotonCalcularPrestamo{urls} urlCalcularPrestamo{url}}}",
  mainMenuSections:
    ROOT +
    "?query={aCSeccionMenuPrincipal(status:PUBLISHED){displayText columna fila titulo url nombreTecnicoTipoContenido aCOpcionesSeccionPersonalizada{contentItems{... on ACOpcionDeSeccionPersonalizada{titulo url}}}}}",
};
export default rutasCMS;
